import { useAuth } from '@/hooks';
import {
  Avatar,
  Flex,
  Text,
  Link,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
} from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';
import { usePermissionGuard } from '@/hooks/usePermissionGuard';
import { SUPPORT_HOME_URL } from '@/constants/app-constants';
import { useKFlags } from '@/hooks/use-k-flags';

export const NavProfile = ({ isCollapsed }) => {
  const { currUser: user, logout } = useAuth();
  const { feSettingsNav, ats_enabled } = useKFlags();
  const history = useHistory();
  const { isAccountInviteEnabled } = usePermissionGuard();

  const onLogout = async () => {
    await logout();
  };

  const redirectToURL = () => {
    window.open(`${SUPPORT_HOME_URL}`, '_blank');
  };

  const handleInviteMember = () => {
    const link = ats_enabled
      ? '/settings/users-roles'
      : feSettingsNav
      ? '/settings/org/users'
      : '/settings/org';
    history.push(link);
  };

  return (
    <Menu placement="right-start">
      <Flex
        mt="16px"
        borderRadius="6px"
        p="6px 10px"
        alignItems="center"
        cursor="pointer"
        w={isCollapsed ? 'full' : '225px'}
      >
        <MenuButton w="full">
          <Link
            as={Flex}
            _focus={{ outline: 'none' }}
            alignItems="center"
            display="flex"
            // to={feSettingsNav ? '/settings/profile/general' : '/settings/profile'}
            textDecoration="none  !important"
          >
            <Avatar
              name={`${user?.first_name} ${user?.last_name}`}
              src={user?.avatar}
              width="24px"
              height="24px"
              borderRadius="6px"
              className="avatar-md"
            />

            {!isCollapsed && (
              <Text ml="12px" size="sm-medium" textAlign="left">
                {user?.first_name} {user?.last_name}
              </Text>
            )}
          </Link>
        </MenuButton>
        <MenuList ml="10px" zIndex={999}>
          {isAccountInviteEnabled && (
            <MenuItem onClick={handleInviteMember}>Invite teammates</MenuItem>
          )}
          <MenuItem onClick={redirectToURL}>Help & Support</MenuItem>
          <MenuItem onClick={onLogout}>Logout</MenuItem>
        </MenuList>
      </Flex>
    </Menu>
  );
};
